import {Component} from '@angular/core';
import {BlockBaseComponent} from "../block-base/block-base.component";
import {MatDialog} from "@angular/material/dialog";
import {TranslocoService} from "@ngneat/transloco";
import {StoreSelectorsService} from "../../../../services";

@Component({
    selector: 'app-scene-block-podcast',
    templateUrl: './block-podcast.component.html',
    styleUrls: ['./block-podcast.component.scss']
})
export class BlockPodcastComponent extends BlockBaseComponent {
    rssNames = [];

    constructor(private translocoService: TranslocoService, public override storeSelector: StoreSelectorsService, public override dialog: MatDialog) {
        super(storeSelector, dialog);
        const rssLinks = {
            custom: 'custom',
            'http://rss.cnn.com/services/podcasting/studentnews/rss.xml': 'CNN Student',
            'http://feeds.cbsnews.com/podcast_eveningnews_video_1': 'CBS Evening News',
            'http://feeds.feedburner.com/tedtalks_video': 'Ted Talks',
            'http://feeds.feedburner.com/cnet/news': 'CNET.COM News',
            'http://feeds.feedburner.com/cnet/firstlook': 'CNET.COM First Look',
            'http://www.democracynow.org/podcast-video.xml': 'Democracy Now',
            'http://www.kqed.org/rss/checkplease.xml': 'Kqed CheckPlease',
            'http://www.doctorfloyd.com/video/rss.xml': 'Dr. Floyd',
            'http://divefilm.com/podcasts/podcast.xml': 'Dive Film',
            'http://feeds.feedburner.com/AmazingFactsPresents': 'Amazing Facts with Doug Batchelor',
            'http://feeds.feedburner.com/CSHVideo': 'CSH',
            'http://www.oakfan.com/BDHVodcast.xml': 'Bringing Disneyland Home',
            'http://playhousetv.podomatic.com/rss2.xml': 'PlayHouse TV',
            'http://feeds.twit.tv/twit_video_large': 'TWIT TV',
            'http://www.feedforall.com/rss-video-tutorials.xml': 'Feed For All'
        };
        Object.keys(rssLinks).forEach(field => {
            this.rssNames.push({
                optionsLabel: rssLinks[field],
                optionValue: field,
                optionType: 'text'
            });
        });
    }

    override submit(formValues) {
        const foundIndex = this.rssNames.findIndex((v) => v.optionValue === formValues.feed);
        if (foundIndex !== 0) formValues.url = this.rssNames[foundIndex].optionValue;
        super.submit(formValues);
    }

    override componentInit() {
        super.componentInit();
    }

    override componentStoreUpdates() {
        const url = this.sceneItem.Data[0].Rss[0].$.url;
        this.setFormValue('url', url);
        const foundIndex = this.rssNames.findIndex((v) => v.optionValue === url);
        if (foundIndex === -1) {
            this.setFormValue('feed', 'custom');
        } else {
            this.setFormValue('feed', url);
        }
        super.componentStoreUpdates();
    }

    override initRegisterDynamic() {
        this.uiConfigInit = [
            {
                type: "select",
                label: this.translocoService.translate('general.feed', {}, this.translocoService.getActiveLang()),
                name: "feed",
                value: "",
                options: this.rssNames,
                ignoreMissingValue: true
            },
            {
                type: "input",
                value: "",
                label: this.translocoService.translate('general.url', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                name: "url",
                storePath: 'Data[0].Rss[0].$.url'
            },
            {
                type: "checkbox",
                value: '1',
                label: this.translocoService.translate('general.maintainRatio', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                name: "maintainAspectRatio",
                storePath: 'Data[0].Rss[0].$.maintainAspectRatio'
            }
            // ,{
            //     type: "checkbox",
            //     value: '1',
            //     label: this.translocoService.translate('general.gpu', {}, this.translocoService.getActiveLang()),
            //     name: "gpu",
            //     storePath: '$.gpu'
            // }
        ];
    }
}

